<template>
    <div class="aboutus">
        <div class="aboutus-banner">
            <div class="banner-item" v-for="(content, index) in topContent.filter(e=>e.note === 'banner')" :key="index" v-html="content.content"></div>
            <div class="tab">
                <div class="tab-view">
                <span :class="['tab-view__item', index === tagIndex ? 'active' : '']"
                      v-for="(item, index) in items"
                      :key="index" @click="handleChangeTabIndex(item, index)">
                    {{ item.name }}
                </span>
                </div>
            </div>
            <section v-if="showFixedPage">
                <div class="banner-item" style="margin-bottom: 40px;" v-for="(content, index) in topContent.filter(e=>e.note === 'content')" :key="index" v-html="content.content"></div>
            </section>
        </div>

        <div class="aboutus-fixed" v-if="showFixedPage">
            <div class="aboutus-time" v-if="fixedList.length > 0">
                <div class="time-banner"></div>
                <div class="time-content">
                    <div class="tab">
                        <el-icon color="#FFFFFF" size="16" @click="handleChangeIndex(-1)"><ArrowLeft /></el-icon>
                        <div :class="['tab-view', activeIndex === index ? 'active' : '']" v-for="(time, index) in fixedList" :key="index" @click="handleChangeActiveIndex(index)">
                            {{ time.title }}
                        </div>
                        <el-icon color="#FFFFFF" size="16" @click="handleChangeIndex(1)"><ArrowRight /></el-icon>
                    </div>
                    <div class="content" v-html="activeContent.content"></div>
                </div>
            </div>
            <div class="aboutus-content">
                <div class="banner-item" style="margin-bottom: 60px;" v-for="(content, index) in bottomContent" :key="index" v-html="content.content"></div>
            </div>
        </div>
        <div v-else class="aboutus-res-content">
            <div class="res-content" v-html="activeNew.content"></div>
        </div>
    </div>
</template>

<script>
import mixin from '@/mixin'
import router from "@/route";
import {useStore} from "vuex";
import {gsap} from "gsap";
import {tableData} from "@/common/api";
import {ElMessage} from "element-plus";
export default {
    name: "aboutVue",
    mixins: [mixin],
    data() {
        return {
            tagIndex: 0,
            activeIndex: 0,
            items: [],
            store: useStore(),
            data: {
                content: "",
            },
            bannerList: [],
            activeContent: {},
            activeNew: {},
            topContent: [],
            bottomContent: [],
            bannerSrc: "",
            fixedList: [],
            activeTag: 0,
            tabList: [{name: "企业荣誉"} , {name: "技术支持"}],
            showFixedPage: true
        }
    },
    methods: {
        handleChangeTabIndex(item, index) {
            this.tabIndex = index;
            router.push({
                path: item.route,
                query: {
                    menuId: item.id,
                    level: item.level,
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeTag: index,
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                }
            })
        },
        handleTagClick(item, index) {
            router.push({
                path: location.pathname,
                query: {
                    menuId: new URL(location.href).searchParams.get('menuId'),
                    level: new URL(location.href).searchParams.get('level'),
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeTag: index,
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                }
            })
        },
        handleChangeActiveIndex(index) {
            this.activeIndex = index;
            this.activeContent = this.fixedList[this.activeIndex]
        },
        handleChangeIndex(index) {
            this.activeIndex += index;
            if(this.activeIndex < 0) {
                this.activeIndex = 0
            }else if(this.activeIndex > this.fixedList.length - 1){
                this.activeIndex = this.fixedList.length - 1
            }
            this.activeContent = this.fixedList[this.activeIndex]
        },
        initPage(id) {
            tableData(id).then(res=> {
                if(res.success) {
                    this.showFixedPage = false;
                    this.activeNew = res.data[0]
                    console.log( res.data)
                }else {
                    ElMessage.error(res.msg)
                }
            }).catch(()=> {
                ElMessage.error("获取资源详情失败，请重试")
            })
        },
    },
    created() {
        window.scrollTo(0, 0)
        this.getBanner("aboutus");
    },
    mounted() {
        this.$nextTick(()=> {
            gsap.set(".aboutus-banner", {
                opacity: 0
            })
            gsap.to(".aboutus-banner",{
                opacity: 1,
                duration: 1.5
            })
            let level = new URL(location.href).searchParams.get('level')
            let menuId = new URL(location.href).searchParams.get('menuId')
            let parentId = new URL(location.href).searchParams.get('parentId')
            this.items = this.store.getters.getMenuList.filter(e=> e.id === parentId)[0].list
            if(parseInt(level) === 2) {
                this.showFixedPage = false;
                this.initPage(menuId)
            }else {

                console.log(this.items)
                this.showFixedPage = true;
            }
            this.tagIndex = parseInt(new URL(location.href).searchParams.get('activeTag'))
        })
    }
}
</script>

<style lang="less" scoped>
    ::v-deep img {
        width: 100%;
    }
    .aboutus {
        width: 100%;
        background: #FFFFFF;
        .aboutus-res-content {
            margin:0 0 40px 0;
        }
        .aboutus-banner {
            width: 100%;
            overflow: hidden;
            .tab {
                width: 100%;
                border-bottom: 1px solid #DFDFDF;
                margin-bottom: 60px;
                display: flex;
                .tab-view {
                    width: 1200px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: flex-end;
                    .tab-view__item {
                        font-size: 18px;
                        line-height: 1;
                        color: #333333;
                        padding: 24px 0;
                        margin-left: 90px;
                        cursor: pointer;
                        transition: color 0.3s;
                        &.active {
                            color: #FF6900;
                        }
                        &:hover {
                            color: #FF6900;
                        }
                    }
                }
            }
        }
        .aboutus-tab {
            width: 100%;
            border-bottom: 1px solid #DFDFDF;
            display: flex;
            .aboutus-tab__view {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-end;
                .item {
                    font-size: 18px;
                    line-height: 1;
                    color: #333333;
                    padding: 24px 0;
                    margin-left: 90px;
                    cursor: pointer;
                    transition: color 0.3s;
                    &.active {
                        color: #FF6900;
                    }
                    &:hover {
                        color: #FF6900;
                    }
                }
            }
        }
        .aboutus-content {
            margin: 60px auto;
            ::v-deep img {
                width: 100%;
                height: auto;
            }
        }
        .aboutus-fixed {
            min-height: 500px;
            .aboutus-time {
                .time-banner {
                    width: 100%;
                    height: 180px;
                    background-image: url("~@/assets/time-banner.png");
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: cover;
                }
                .time-content {
                    .tab {
                        width: 100%;
                        height: 60px;
                        line-height: 60px;
                        background-color: #FF6900;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .el-icon {
                            cursor: pointer;
                            &:nth-of-type(1) {
                                margin-right: 10px;
                            }
                            &:nth-of-type(2) {
                                margin-left: 10px;
                            }
                            &:hover {
                                transform: scale(1.3);
                            }
                        }
                        .tab-view {
                            margin: 0 20px;
                            color: #FFFFFF;
                            font-size: 18px;
                            line-height: 24px;
                            cursor: pointer;
                            &.active {
                                font-size: 24px;
                                font-weight: bold;
                            }
                        }
                    }
                    .content {
                        width: 100%;
                        height: 256px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        ::v-deep p {
                            overflow: hidden;
                        }
                    }
                }

            }
        }
    }
</style>
